module.exports = __webpack_public_path__ + "static/media/meteringicon01@2x.e0eb8294.png";